import { Rating } from 'semantic-ui-react';

export default Rating;
